module.exports = __webpack_public_path__ + "img/5.866335ce.png";